import { endOfDay, parseISO } from 'date-fns';

/**
 * Whether a workgroup instance's period overlaps a date range.
 *
 * An instance runs from its `startDate` to the end of its `endDate`'s day (the backend stores it as
 * 23:59:59 in the template's timezone); a missing date is open-ended. The range's days are inclusive.
 *
 * @param {{ startDate?: number|string, endDate?: number|string }} workgroup - Instance from workgroups/instance/prm
 * @param {{ fromDate: string, toDate: string }} range - 'yyyy-MM-dd' dates, e.g. the dashboard header's
 * @returns {boolean}
 */
export default function isWorkgroupInRange({ startDate, endDate }, { fromDate, toDate }) {
  const rangeStart = parseISO(fromDate).getTime();
  const rangeEnd = endOfDay(parseISO(toDate)).getTime();
  const startsBeforeRangeEnds = startDate == null || new Date(startDate).getTime() <= rangeEnd;
  const endsAfterRangeStarts = endDate == null || new Date(endDate).getTime() >= rangeStart;
  return startsBeforeRangeEnds && endsAfterRangeStarts;
}
